<div class="component-container player-stats"
     [class]="controlAction">
  <div class="image"
       [style.background-color]="getTeamBgr()"
  >
<!--
    <div class="team-img" [style]="getBgrWithOverlay()"></div>
-->
    <div class="team">
      {{ broadcast?.config?.skinId === 'ODM' ? 'STATISTIKY' : 'PITCHING STATS' }}
    </div>
  </div>
  <div class="stats"
       [class]="this.game?.currentPitcher?.gameStats?.pitching?.ip >= 1 && this.game?.currentPitcher?.seasonStats?.pitching?.ip >= 1 ? '' : ''">
    <div class="name"
         [style.background-color]="getTeamBgr()">
      <div [style.font-size]="getFontSize(game?.currentPitcher)">{{getNumber()}} {{getName().toUpperCase()}}</div>
    </div>
    <div class="data season" *ngIf="season">
      <div class="stats-header">
        <div>
          SEASON
        </div>
      </div>
      <div>
        <div>IP</div>
        <div>{{ game?.currentPitcher?.seasonStats?.pitching?.ip ? (game?.currentPitcher?.seasonStats?.pitching?.ip | number : ".1-1") : "0.0" }}</div>
      </div>
      <div>
        <div>ERA</div>
        <div>{{ game?.currentPitcher?.seasonStats?.pitching?.era != null ? (game?.currentPitcher?.seasonStats?.pitching?.era | number : ".2-2") : "-" }}</div>
      </div>
      <div>
        <div>K</div>
        <div>{{ game?.currentPitcher?.seasonStats?.pitching?.k ? game?.currentPitcher?.seasonStats?.pitching?.k : 0 }}</div>
      </div>
      <div>
        <div>BB</div>
        <div>{{ game?.currentPitcher?.seasonStats?.pitching?.bb ?  game?.currentPitcher?.seasonStats?.pitching?.bb : 0 }}</div>
      </div>
    </div>
    <div class="data today" *ngIf="!season">
      <div class="stats-header">
        <div>
          TODAY
        </div>
      </div>
      <div>
        <div>IP</div>
        <div>
          {{ game?.currentPitcher?.gameStats?.pitching?.ip ? (game?.currentPitcher?.gameStats?.pitching?.ip | number : ".1-1") : "0.0" }}
        </div>
        <div>PIT</div>
        <div>
          {{ game?.currentPitcher?.gameStats?.pitching?.pitches ? (game?.currentPitcher?.gameStats?.pitching?.pitches) : 0 }}
        </div>
      </div>
      <div>
        <div>ER</div>
        <div>
          {{ game?.currentPitcher?.gameStats?.pitching?.er != null ? (game?.currentPitcher?.gameStats?.pitching?.er) : 0 }}
        </div>
        <div>STR</div>
        <div>
          {{ game?.currentPitcher?.gameStats?.pitching?.strikes ? (game?.currentPitcher?.gameStats?.pitching?.strikes) : 0 }}
        </div>
      </div>
      <div>
        <div>RA</div>
        <div>
          {{ game?.currentPitcher?.gameStats?.pitching?.ra != null ? (game?.currentPitcher?.gameStats?.pitching?.ra) : 0 }}
        </div>
        <div>K</div>
        <div>
          {{ game?.currentPitcher?.gameStats?.pitching?.k ? game?.currentPitcher?.gameStats?.pitching?.k : 0 }}
        </div>
      </div>
      <div>
        <div>H</div>
        <div>
          {{ game?.currentPitcher?.gameStats?.pitching?.h ?  game?.currentPitcher?.gameStats?.pitching?.h : 0 }}
        </div>
        <div>BB</div>
        <div>
          {{ game?.currentPitcher?.gameStats?.pitching?.bb ?  game?.currentPitcher?.gameStats?.pitching?.bb : 0 }}
        </div>
      </div>
    </div>
  </div>
</div>
